module.exports = __webpack_public_path__ + "img/pancakeswap.8fd0898d.png";